import { bioBased, star } from "../../assets/icons";
import styles from "./searchResultInfo.module.css";
export default function SearchResultInfo({iconType}: {iconType: string}) {
    if(iconType && iconType == "popular") {
        return(
            <div className={styles.info}>
                {star}
                <span>Popular alternative</span>
            </div>
        )
    } else {
        return(
            <div className={styles.info}>
                {bioBased}
                <span>Bio-based</span>
            </div>
        )
    }
}